// utilities
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, /**
 * Handles saving image group.
 *
 * @param {Object} groupImageData - An object containing image data grouped by image ID.
 * @param {Function} save - A function to save the images.
 * @returns {Promise} - A Promise that resolves when image saving is complete.
 *
 * @example
 *
 * // Example usage:
 * const groupImageData = {
 *    imageId: {
 *      ref: () => {}, // Function to get is2u file
 *      img: 'preview', // Image preview
 *      json: {} // Image info
 *    }
 * };
 * const saveFunction = () => {...}; // Function to save images
 * await handleSaveImages(groupImageData, saveFunction);
 */ "default", {
    enumerable: true,
    get: function() {
        return handleSaveImages;
    }
});
const _ = require(".");
async function handleSaveImages(groupImageData = {}, save = ()=>{}) {
    for (const [id, data = {}] of Object.entries(groupImageData)){
        if (!id) return;
        const { DATA = {} } = data;
        const { img = {}, json = {}, exportImage } = DATA;
        // convert preview to blob -->
        const preview = img.src;
        const previewBuffer = (0, _.dataURIToArrayBuffer)(preview);
        // export an .is2 if valid callback -->
        if (exportImage) {
            // pack updated is2 using valid IRRenderer instance
            const file = await exportImage(json, previewBuffer);
            save(id, file);
        }
    }
}
